<template>
  <rhcn-drawer
    title="message.user.updatePassword"
    @on-close="onClose">
    <div class="drawer-form">
      <validation-component
        ref="resetPwdFormRef"
        :validation-condition="resetPwdCondition">
      </validation-component>
      <div class="margin-top-18">
        <el-button :loading="resetPwdLoading" style="width:100%;" type="primary" @click="resetPwdSubmit">{{$t('message.common.confirm')}}</el-button>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import { resetPassword } from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import {
  REQUIRED, VALIDATE_PASSWORD, PASSWORD_LENGTH, PASSWORD_STRENGTH,
  EMAIL,
} from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';

export default {
  components: { RhcnDrawer, ValidationComponent },
  data() {
    return {
      resetPwdCondition: [
        {
          key: 'email',
          name: 'message.user.loginEmail',
          type: 'input',
          defValue: '',
          rule: [],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.loginEmail').toLowerCase() }),
          isShowStar: true,
          validator: this.validateEmail,
        },
        {
          key: 'oldPassword',
          name: 'message.user.oldPassword',
          type: 'password',
          defValue: '',
          rule: [],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.oldPassword').toLowerCase() }),
          isShowStar: true,
          validator: this.validateOldPwd,
        },
        {
          key: 'password',
          name: 'message.user.newPasword',
          type: 'password',
          defValue: '',
          rule: [],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.newPasword').toLowerCase() }),
          isShowStar: true,
          validator: this.validatePassword,
        },
        {
          key: 'confirmPassword',
          name: 'message.user.confirmPasword',
          type: 'password',
          defValue: '',
          rule: [],
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.confirmPasword').toLowerCase() }),
          isShowStar: true,
          validator: this.validateConfirmPassword,
        },
      ],
      resetPwdLoading: false,
    };
  },
  created() {
  },
  methods: {
    resetPwdSubmit() {
      this.$refs.resetPwdFormRef.toFormValid(this.resetPwdHttpRequest);
    },
    async resetPwdHttpRequest() {
      this.resetPwdLoading = true;
      try {
        const data = this.$refs.resetPwdFormRef.getFormJson();
        data.email = data.email.trim();
        await resetPassword({
          email: data.email,
          oldPassword: data.oldPassword,
          password: data.password,
        });
        this.$router.push({ path: '/user/login', query: { loginId: encodeURIComponent(data.email) } });
        ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
      } catch (err) {
        //
      }
      this.resetPwdLoading = false;
    },
    onClose() {
      window.history.back();
    },
    validateEmail(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.loginEmail') })));
        return;
      }
      // 邮箱格式验证
      if (!EMAIL.regExp.test(value)) {
        callback(new Error(this.$t(EMAIL.tips)));
        return;
      }
      callback();
    },
    validateOldPwd(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.oldPassword') })));
        return;
      }
      callback();
    },
    validatePassword(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.permission.newPasword') })));
        return;
      }
      // 密码格式验证
      if (this.$refs.resetPwdFormRef.getItemValue('oldPassword') === value) { // 不能与原密码相同
        callback(new Error(this.$t('message.validator.newPasswordConfirm')));
        return;
      }
      if (!VALIDATE_PASSWORD.regExp.test(value)) {
        callback(new Error(this.$t(VALIDATE_PASSWORD.tips)));
        return;
      }
      if (!PASSWORD_LENGTH.regExp.test(value)) {
        callback(new Error(this.$t(PASSWORD_LENGTH.tips)));
        return;
      }
      if (!PASSWORD_STRENGTH.regExp.test(value)) {
        callback(new Error(this.$t(PASSWORD_STRENGTH.tips)));
        return;
      }
      callback();
    },
    validateConfirmPassword(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.permission.newPasswordConfirm') })));
        return;
      }
      if (this.$refs.resetPwdFormRef.getItemValue('password') !== value) {
        callback(new Error(this.$t('message.validator.passwordConfirm')));
        return;
      }
      callback();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.line {
  height: 30px;
  background: $color-bg;
  margin: 10px auto 20px;
}
.form-wrapper {
  max-width: 338px;
  margin: 0 auto;
}
</style>
